/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：KI63__part-1
 */

"use strict"

/* harmony export (binding) */
import { _createClass, _classCallCheck, _possibleConstructorReturn, _inherits, __decorate } from "./template-KI63__part-0"
import * as __WEBPACK_IMPORTED_MODULE_3__sensorsData__ from /* yI2H */"../sensorsData-yI2H"
import * as __WEBPACK_IMPORTED_MODULE_2__cfg__ from /* dpNx */"../cfg-dpNx"
import * as __WEBPACK_IMPORTED_MODULE_1_react_css_modules__ from /* 211U */"react-css-modules"
import * as __WEBPACK_IMPORTED_MODULE_0_react__ from /* GiK3 */"react"
import * as styles from /* RQs1 */"./styles-RQs1"
var TemplateItemView = function (_React$Component) {
  _inherits(TemplateItemView, _React$Component)
  function TemplateItemView(props) {
    _classCallCheck(this, TemplateItemView)
    var _this = _possibleConstructorReturn(this, (TemplateItemView.__proto__ || Object.getPrototypeOf(TemplateItemView)).call(this, props))
    _this.state = {
      isNewUser: false
    }
    return _this
  }
  _createClass(TemplateItemView, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
      //
      }
    }, {
      key: "handleTemplateClick",
      value: function handleTemplateClick(id, name) {
        __WEBPACK_IMPORTED_MODULE_3__sensorsData__.sensorsCustomReport("TemplateClick", {
          template_name: name
        })
        var _config = __WEBPACK_IMPORTED_MODULE_2__cfg__.config()
        var cocoEditorUrl = _config.cocoEditorUrl
        window.open(cocoEditorUrl + "?templateId=" + id, Date.now().toString())
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this
        var item = this.props.item
        return __WEBPACK_IMPORTED_MODULE_0_react__.createElement("div", {
          styleName: "templateItem",
          onClick: function onClick() {
            return _this2.handleTemplateClick(item.id, item.name)
          }
        }, __WEBPACK_IMPORTED_MODULE_0_react__.createElement("div", {
          styleName: "image",
          style: {
            backgroundImage: "url(" + item.preview_url + ")"
          }
        }, __WEBPACK_IMPORTED_MODULE_0_react__.createElement("img", {
          src: item.gif_url,
          alt: item.name,
          styleName: "gif"
        })))
      }
    }
  ])
  return TemplateItemView
}(__WEBPACK_IMPORTED_MODULE_0_react__.Component)
TemplateItemView = __decorate([
  __WEBPACK_IMPORTED_MODULE_1_react_css_modules__(styles, {
    allowMultiple: true
  })
], TemplateItemView)

/***/
export { TemplateItemView }
